<template>
  <div>
    <navHeader />
    <div class="container-lg mt-5">
      <div class="row">
        <div class="col-12">
          <!-- report content components -->
          <DailyNotes v-if="showDailyNotes == true" />
          <TradingPlan v-show="false" />
          <Archive v-show="false" />
          <CompanyReports v-show="false" />
          <OtherSpecialReports v-show="false" />
          <ForecastReport v-show="false" />
          <UpcomingDividends v-if="showUpcomingDividends == true" />
          <PreferredDividends v-show="false" />
          <REITs v-show="false"/>
          <StockMomentum  v-show="false"/>
          <MarketSnapshot  v-show="false"/>
          <EarningScorecard v-show="false"/>

          <!-- bottom contents -->
          <!-- <Pagination v-show="false" /> -->
          <Footer />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import navHeader from "../ResearchPages/NavHeader";
import Footer from "../ResearchPages/Footer";
// import Pagination from "../ResearchPages/Pagination";

// reports
import DailyNotes from "../ResearchPages/ReportsPages/DailyNotes";
import TradingPlan from "../ResearchPages/ReportsPages/TradingPlanReport";
import Archive from "../ResearchPages/ReportsPages/Archives";
import CompanyReports from "../ResearchPages/ReportsPages/CompanyReports";
import ForecastReport from "../ResearchPages/ReportsPages/ForecastReport";
import UpcomingDividends from "../ResearchPages/ReportsPages/UpcomingDividends";
import PreferredDividends from "../ResearchPages/ReportsPages/PreferredDividends";
import REITs from "../ResearchPages/ReportsPages/REITs";
import StockMomentum from "../ResearchPages/ReportsPages/StockMomentum";
import MarketSnapshot from "../ResearchPages/ReportsPages/MarketSnapshot";
import EarningScorecard from "../ResearchPages/ReportsPages/EarningScorecard";

export default {
  components: {
    navHeader,

    DailyNotes,
    TradingPlan,
    Archive,
    CompanyReports,
    
    ForecastReport,
    UpcomingDividends,
    PreferredDividends,
    REITs,
    StockMomentum,
    MarketSnapshot,
    EarningScorecard,

    // Pagination,
    Footer
  },
  data() {
    return {
      showDailyNotes:false,
      showTradingPlan:false,
      showCompanyReports:false,
      showUpcomingDividends:false,
      // showDailyNotes:false,
      // showDailyNotes:false,
      // showDailyNotes:false,showDailyNotes:false,
      // showDailyNotes:false,
      // showDailyNotes:false,
      
    }
  },
  
  methods:{
// SwitchTab(data) {

//   },

  }
};
</script>

<style>
</style>